module.exports = __webpack_public_path__ + "img/edit-2.fdac2697.svg";